import { getHost, version } from "@src/env";
import { useMutation } from "@tanstack/react-query";

import { parseJSON } from "@src/utils/json";
import { safeFetch } from "@src/utils/safeFetch";

type ContactForm = {
  name: string;
  email: string;
  phone: string;
  message: string;
};

export function useContactMutation() {
  return useMutation({
    mutationKey: ["contact"],
    mutationFn: async ({ name, email, phone, message }: ContactForm) => {
      const headers = new Headers();
      headers.append("Content-Type", "application/json");
      headers.append("X-Requested-With", "XMLHttpRequest");

      const host = getHost();
      const response = await safeFetch(
        "useContactMutation",
        `${host}/api/contact`,
        {
          method: "POST",
          headers,
          body: JSON.stringify({
            name,
            email,
            phone: phone,
            message,
            player_version: version,
            url: window.location.href,
          }),
        },
      );

      const json = await parseJSON("useContactMutation", response);
      if (!response.ok) {
        throw new Error(json.message);
      }

      return response;
    },
  });
}
